<template>
  <span>
    <span v-show="$store.getters['app/overlays'].show_start_selector_overlay">
      <img draggable="false" class="clickable" id="quit_btn_top" @click="goToHome()" src="./../assets/images/Asset 58.png" alt="">
      <img draggable="false" class="background_image" src="./../assets/images/Asset 47.png" alt="">
      <img draggable="false" id="line_image_2" src="./../assets/images/Asset 42.png" alt="">
      <img @click="GoToPhagwaStart()" draggable="false" class="clickable" id="card_1" src="./../assets/images/Asset 38.png" alt="">
      <img @click="GoToVrijhedenStart()" draggable="false" class="clickable" id="card_2" src="./../assets/images/Asset 37.png" alt="">
      <img @click="GoToEidStart()" draggable="false" class="clickable" id="card_3" src="./../assets/images/Asset 36.png" alt="">
      <img @click="GoToKerstmisStart()" draggable="false" class="clickable" id="card_4" src="./../assets/images/Asset 39.png" alt="">
      <img @click="GoToChineesStart()" draggable="false" class="clickable" id="card_5" src="./../assets/images/Asset 40.png" alt="">
      <img @click="goToMarronsIntro()" draggable="false" class="clickable" id="card_6" src="./../assets/images/Asset 35.png" alt="">
      <img @click="GoToInheemsStart()" draggable="false" class="clickable" id="card_7" src="./../assets/images/Asset 33.png" alt="">
      <img @click="GoToKeukenStart()" draggable="false" class="clickable" id="card_8" src="./../assets/images/Asset 59.png" alt="">
      <img draggable="false" id="chinese_balloon" src="./../assets/images/chinees/Asset 4.png" alt="">

      <img draggable="false" id="table" src="./../assets/images/Asset 62.png" alt="">

      <span id="text">Druk op elk vakje om meer info te krijgen</span>
    </span>
  </span>
</template>

<script>
export default {
  name: "Start",
  mounted() {},

  created() {},
  destroyed() {},

  data() {
    return {};
  },

  methods: {
    goToHome() {
      this.$router.push('/');
      this.$store.dispatch('app/asyncUpdateOverlay', {
          show_start_menu_overlay: true,
          show_start_selector_overlay: false,
      });
    },
    goToGamePage() {
      this.$router.push('/game');
    },
    GoToPhagwaStart() {
      this.$router.push('/phagwa/start');
    },
    GoToKerstmisStart() {
      this.$router.push('/kerstmis/start');
    },
    GoToChineesStart() {
      this.$router.push('/chinees/start');
    },
    goToMarronsIntro() {
      this.$router.push('/marrons/intro');
    },
    GoToInheemsStart() {
      this.$router.push('/inheems/start');
    },
    GoToEidStart() {
      this.$router.push('/eid/start');
    },
    GoToVrijhedenStart() {
      this.$router.push('/vrijheden/start');
    },
    GoToKeukenStart() {
      this.$router.push('/keuken/start');
    },
  },

  computed: {}
};
</script>

<style>
  #line_image_2 {
    position: absolute;
    margin-top: 0;
    left: 0;
    width: 100%;
    height: auto;
  }

  #text {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 25%;
    width: 28%;
    left: 36%;
    color: #69a643;
    font-size: 3vw;
    text-align: center;
  }

  #quit_btn_top {
    position: absolute;
    margin-top: 2%;
    right: 3%;
    width: 15%;
    z-index: 1;
  }

  #reset_btn_top {
    position: absolute;
    margin-top: 9.5%;
    right: 3%;
    width: 15%;
    z-index: 1;
  }

  #card_1 {
    position: absolute;
    margin-top: 31%;
    left: 3%;
    width: 13%;
    height: auto;
  }

  #card_2 {
    position: absolute;
    margin-top: 16%;
    left: 3%;
    width: 13%;
    height: auto;
  }

  #card_3 {
    position: absolute;
    margin-top: 16%;
    left: 20%;
    width: 13%;
    height: auto;
  }

  #card_4 {
    position: absolute;
    margin-top: 3%;
    left: 35%;
    width: 13%;
    height: auto;
  }

  #card_5 {
    position: absolute;
    z-index: 1;
    margin-top: 3%;
    left: 52%;
    width: 13%;
    height: auto;
  }

  #card_6 {
    position: absolute;
    margin-top: 16%;
    left: 67%;
    width: 13%;
    height: auto;
  }

  #card_7 {
    position: absolute;
    margin-top: 16%;
    left: 83%;
    width: 13%;
    height: auto;
  }

  #card_8 {
    position: absolute;
    margin-top: 31%;
    left: 83%;
    width: 13%;
    height: auto;
  }

  #chinese_balloon {
    position: absolute;
    margin-top: 13%;
    left: 56%;
    rotate: 4deg;
    width: 5%;
    height: auto;
  }

  #table {
    position: absolute;
    margin-top: 35%;
    left: 19%;
    width: 65%;
    height: auto;
  }
</style>


